namespace Solovis.Reports.Parameters {

    export class MultiValuedParameterControl extends Solovis.UI.BaseControl {

        private _portalServices: Solovis.Portal.IPortalServices;

        public parameterControlType;
        public _parameterList;
        public initialValue;
        public settings;

        public valueListDiv: JQuery;

        constructor(options, info) {
            super(options, info);

            if (options.portalServices) {
                this._portalServices = options.portalServices;
            }
            else {
                this._portalServices = new Solovis.Portal.SitePortalServices();
            }

            this.transition = null;

            this.parameterControlType = options.parameterControlType ? options.parameterControlType : null;

            this._parameterList = options.parameterList ? options.parameterList : null;

            this.initialValue = Solovis.isNotNull(options.initialValue) ? options.initialValue : null;
            this.settings = Solovis.isNotNull(options.settings) ? options.settings : null;
        }

        
        public doRender() {
            var self = this;

            this.valueListDiv = $("<div>").appendTo(this.container);
            this.valueListDiv.addClass('multi-valued-parameter-control')
            if (this.initialValue && this.initialValue.length > 0) {
                // Add existing values if we have loaded existing values.
                $(this.initialValue).each(function (i, existingValue) {
                    self._addNewValueRow(existingValue);
                });
            }
            else {
                this._addNewValueRow(null);
            }

            // Show link for adding new value.
            var addNewValueRow = $("<div>").appendTo(this.container);

            var addNewValueLink = $("<a>").css("font-size", "13px").text("Add Value").appendTo(addNewValueRow)
                .click(function () {
                    self._addNewValueRow(null);
                });
        }

        public _addNewValueRow(initialValue) {
            var self = this;

            var valueDiv = $("<div>").appendTo(this.valueListDiv);
            valueDiv.css({ 
                "border-bottom": "1px solid #ccc",
                "padding-bottom": "3px",
                "margin-bottom": "3px",
                "display": "flex",
                "align-items": "center",
                "gap": "10px",
            });
            valueDiv.addClass('multi-valued-parameter-line-item');

            var valueDivElement = valueDiv.get(0);

            var removeLink = $("<a>")
                .html('<span class="fa fa-times"></span>')
                .attr("title", "Remove")
                .css({"color": "#444", "font-size": "x-small"})
                .appendTo(valueDiv)
                .click(function () {
                    self._removeValueRow(valueDivElement);
                });

            var upLink = $("<a>")
                .html('<span class="fa fa-arrow-up"></span>')
                .attr("title", "Move Up")
                .css({"color": "#444", "font-size": "x-small"})
                .appendTo(valueDiv)
                .click(function () {
                    self._moveValueRowUp(valueDivElement);
                });

            var downLink = $("<a>")
                .html('<span class="fa fa-arrow-down"></span>')
                .attr("title", "Move Down")
                .css({"color": "#444", "font-size": "x-small"})
                .appendTo(valueDiv)
                .click(function () {
                    self._moveValueRowDown(valueDivElement);
                });

            var editorDiv = $("<div>").appendTo(valueDiv);

            var editorInfo = this._createEditorControl(editorDiv, initialValue);

            (valueDivElement as any).__editorInfo = editorInfo;
            (valueDivElement as any).__editorDiv = editorDiv;
        }


        public _createEditorControl(container, initialValue) {
            var self = this;

            container.attr('data-parameter-type', this.info.parameterType)

            var parameterControl = new this.parameterControlType({
                controlHost: container,
                parameterList: this._parameterList,
                initialValue: initialValue,
                settings: self.settings,
                portalServices: this._portalServices,
                renderMode: self.options.renderMode
            }, self.info);

            parameterControl.setAsCurrentControl();

            var editorInfo = {
                parameterControl: parameterControl
            };

            $(parameterControl).bind('parameterValueChanged', function () {
                self.notifyParameterValueChanged();
            });

            return editorInfo;
        }

        public _removeValueRow(valueDivElement) {
            $(valueDivElement).remove();

            this.notifyParameterValueChanged();
        }

        public _moveValueRowUp(valueDivElement) {
            var index = $(valueDivElement).index();
            if (index > 0) {
                var prevItem = $(valueDivElement).prev();
                $(valueDivElement).insertBefore(prevItem);

                this.notifyParameterValueChanged();
            }
        }

        public _moveValueRowDown(valueDivElement) {
            var index = $(valueDivElement).index();
            var totalCount = this.valueListDiv.children("div").length;
            if (index < totalCount) {
                var nextItem = $(valueDivElement).next();
                if (nextItem) {
                    $(valueDivElement).insertAfter(nextItem);

                    this.notifyParameterValueChanged();
                }
            }
        }


        public setParameterValue(newValue) {
            var self = this;

            this.valueListDiv.html("");

            if (newValue && newValue.length > 0) {
                $(newValue).each(function (i, item) {
                    self._addNewValueRow(item);
                });
            }
            else {
                this._addNewValueRow(null);
            }
        }

        public getParameterValue() {
            if (this.valueListDiv) {
                var values = [];

                this.valueListDiv.children("div").each(function (i, valueDivElement: any) {
                    var editorInfo = valueDivElement.__editorInfo;

                    var value = editorInfo.parameterControl.getParameterValue();

                    if (value !== null) {
                        values.push(value);
                    }
                });

                return values;
            }
            else {
                return this.initialValue;
            }
        }

        public notifyParameterValueChanged = function () {
            $(this).trigger("parameterValueChanged");
        }

    }

}


    